import * as yup from "yup";

export function borrowOrRepaySchema() {
  return yup
    .object({
      amount: yup.string().required("وارد کردن مقدار الزامی است.").min(0),
      coinId: yup.number().required(),
    })
    .required();
}
